import { RoleEnum } from '../interfaces/permission.interface';
import { StorageService } from '../services/storage.service';

export const SYSTEM_SUPER_ADMIN_HOME = '/admin/setting/organisations';

export function getRolesFromAuthToken(
  storage: StorageService,
): string[] {
  try {
    const detail = storage.getDetailFromToken() as { roles?: string[] };
    return detail.roles ?? [];
  } catch {
    return [];
  }
}

export function isSystemSuperAdminFromToken(
  storage: StorageService,
): boolean {
  return getRolesFromAuthToken(storage).includes(RoleEnum.SUPER_ADMIN);
}
